import { LazyLoadImage } from "react-lazy-load-image-component";
import bprLogoWhite from "../../assets/img/logo/logobprwhite.png";

export default function Header() {
    const dateNow = new Date().toLocaleDateString('id-ID', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
    return (
        <div className="bg-gray-800 text-white p-4 ">
            <div className="max-w-screen-xl mx-auto flex justify-between items-center">
                <LazyLoadImage
                    src={bprLogoWhite}
                    alt="bpr logo"
                    width="270"
                    height="87"
                    effect="blur"
                    className='w-44 md:w-[270px]'
                    wrapperProps={{
                        style: { transitionDelay: "1s" },
                    }}
                />

                <div>
                    <p className="font-bold text-xl">Palu, {dateNow}</p>
                </div>
            </div>
        </div>
    )
}